import { all, put, call, fork, take } from "redux-saga/effects";
import * as api from "../../utils/api";
import { marketGoalActions, GET_MARKETGOALS_REQUEST } from "./actions";

export function* asyncGetMarketGoals({ payload, resolve, reject }) {
  try {
    const response = yield call(api.getMarketGoals, payload);
    if (response.status === 200 && response.data) {
      yield put(marketGoalActions.getMarketGoalsSuccess(response.data));
    }
    resolve(response.data);
  } catch (err) {
    reject(err);
  }
}

export function* watchGetMakretGoals() {
  while (true) {
    const action = yield take(GET_MARKETGOALS_REQUEST);
    yield* asyncGetMarketGoals(action);
  }
}

export default function* () {
  yield all([fork(watchGetMakretGoals)]);
}
